import {
    createSearchParams,
    useLocation,
    useNavigate,
    useSearchParams,
} from 'react-router-dom'
import {
    Button,
    Container,
    Fab,
    ImageList,
    ImageListItem,
    Tooltip,
    Typography,
} from '@mui/material'
import { Ear } from '../../../../../components/Ear'
import { useInnsynContext } from '../../../../../context/InnsynContextProvider'
import {
    INNSYN_SEARCH_OEREMERKE_BASE_SNITT_PATH,
    INNSYN_SEARCH_OEREMERKE_PATH,
} from '../../../../../paths'
import { FormattedMessage } from 'react-intl'
import { useEffect, useState } from 'react'
import NavigationHeader from '../../../../../components/NavigationHeader'
import colors from '../../../../../styles/colors.scss'
import '../selectCut.scss'

export const SelectCutCombination = () => {
    const navigate = useNavigate()
    const { state } = useLocation() as RightEar
    const [query, setQuery] = useSearchParams()
    const { merker, snitt } = useInnsynContext()
    const cut_pos = query.get('cut_pos')
    const selectedBaseCutString = query.get('selected_base_cut')
    const areaStringArray = query.getAll('a')
    const districtStringArray = query.getAll('d')
    const siidaStringArray = query.getAll('s')
    const selectedBaseCut = snitt?.filter(
        (snitt) =>
            selectedBaseCutString &&
            snitt.id === parseInt(selectedBaseCutString)
    )[0]

    const [chosenSnitt, setChosenSnitt] = useState<Snitt | undefined>(
        selectedBaseCut
    )

    const hasNoAreaDistrictOrSiidaSelected = () => {
        return (
            areaStringArray.length === 0 &&
            districtStringArray.length === 0 &&
            siidaStringArray.length === 0
        )
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const getCutsForEarPosition = () => {
        const filteredMerkesakDataSetForCurrentPositionAndGeography =
            merker
                ?.filter(
                    (el) =>
                        areaStringArray.length === 0 ||
                        areaStringArray.some(
                            (areaString) =>
                                areaString === el.omraadeId.toString()
                        ) ||
                        siidaStringArray.some(
                            (siidaString) =>
                                siidaString === el?.siidaId?.toString()
                        )
                )
                .filter(
                    (el) =>
                        districtStringArray.length === 0 ||
                        districtStringArray.some(
                            (districtString) =>
                                districtString === el?.distriktId?.toString()
                        ) ||
                        siidaStringArray.some(
                            (siidaString) =>
                                siidaString === el?.siidaId?.toString()
                        )
                )
                .filter(
                    (el) =>
                        siidaStringArray.length === 0 ||
                        siidaStringArray.some(
                            (siidaString) =>
                                siidaString === el?.siidaId?.toString()
                        )
                )
                .map((el) => {
                    const pos_key = `snittPosisjon${cut_pos}` as keyof Merke
                    return {
                        snittIdForCurrentPosition: el[pos_key],
                        ...el,
                    } as ExtendedMerke
                }) || []

        return (
            snitt
                ?.filter((cut) => cut_pos && cut.posisjon === parseInt(cut_pos))
                ?.filter(
                    (cut) =>
                        selectedBaseCut?.bokstavkombinasjon &&
                        cut.bokstavkombinasjon.includes(
                            selectedBaseCut.bokstavkombinasjon
                        )
                )
                ?.filter(
                    (cut) =>
                        hasNoAreaDistrictOrSiidaSelected() ||
                        filteredMerkesakDataSetForCurrentPositionAndGeography.find(
                            (merkeSak) => {
                                return (
                                    merkeSak.snittIdForCurrentPosition ===
                                    cut.bokstavkombinasjon
                                )
                            }
                        )
                )
                ?.sort((s1, s2) => {
                    return (
                        s1.bokstavkombinasjon.length -
                            s2.bokstavkombinasjon.length ||
                        s1.bokstavkombinasjon.localeCompare(
                            s2.bokstavkombinasjon
                        )
                    )
                }) || []
        )
    }
    return (
        <>
            <Container>
                <NavigationHeader
                    onClickBack={() =>
                        navigate(
                            {
                                pathname:
                                    INNSYN_SEARCH_OEREMERKE_BASE_SNITT_PATH,
                                search: `?${query}`,
                            },
                            { state: { isRightEar: state?.isRightEar } }
                        )
                    }
                />
                <Typography
                    sx={{
                        fontSize: '1.25rem',
                        marginTop: '1.25rem',
                        marginBottom: '1.75rem',
                        display: 'flex',
                        flexDirection: 'row',
                    }}>
                    <Fab
                        sx={{
                            marginRight: '1rem',
                            width: '2.25rem',
                            minWidth: '2.125rem',
                            height: '1rem',
                            backgroundColor: 'white',
                            outline: `${colors.blue} solid 1px`,
                            boxShadow: 'none',
                        }}>
                        <div
                            style={{
                                fontSize: '1.25rem',
                                color: colors.blue,
                            }}>
                            2
                        </div>
                    </Fab>
                    <div style={{ fontSize: '1.125rem', minWidth: '10rem' }}>
                        <FormattedMessage
                            id={'select-cut-combination.header'}
                        />
                    </div>
                </Typography>
                <ImageList
                    sx={{
                        width: '100%',
                        height: '100%',
                        paddingBottom: '4rem',
                    }}
                    cols={2}
                    gap={4}>
                    {getCutsForEarPosition().map((cut) => (
                        <Tooltip
                            arrow
                            title={cut.bokstavkombinasjon}
                            placement='top'
                            key={'tooltip-' + cut.id}>
                            <ImageListItem key={cut.id}>
                                <div
                                    className='chosenCut'
                                    id={cut.id.toString()}
                                    style={{
                                        paddingLeft: '0.25rem',
                                        outline:
                                            chosenSnitt &&
                                            cut.bokstavkombinasjon ===
                                                chosenSnitt.bokstavkombinasjon
                                                ? `${colors.blue} solid 3px`
                                                : '',
                                    }}
                                    onClick={() => {
                                        setChosenSnitt(cut)
                                    }}>
                                    <div style={{ margin: '0.25rem' }}>
                                        <Ear
                                            cuts={[cut]}
                                            show={
                                                cut_pos &&
                                                (parseInt(cut_pos) === 1 ||
                                                    parseInt(cut_pos) === 2 ||
                                                    parseInt(cut_pos) === 3)
                                                    ? 'right'
                                                    : 'left'
                                            }
                                        />
                                    </div>
                                </div>
                            </ImageListItem>
                        </Tooltip>
                    ))}
                </ImageList>
                <Button
                    onClick={() => {
                        chosenSnitt &&
                            query.append(
                                `pos_${cut_pos}`,
                                chosenSnitt.id.toString()
                            )
                        query.delete('selected_base_cut')
                        query.delete('cut_pos')
                        setQuery(query)
                        navigate(
                            {
                                pathname: INNSYN_SEARCH_OEREMERKE_PATH,
                                search: `?${createSearchParams(query)}`,
                            },
                            {
                                replace: true,
                                state: {
                                    isRightEar:
                                        cut_pos &&
                                        (parseInt(cut_pos) === 1 ||
                                            parseInt(cut_pos) === 2 ||
                                            parseInt(cut_pos) === 3),
                                },
                            }
                        )
                    }}
                    size='medium'
                    variant='contained'
                    sx={{ position: 'fixed', marginBottom: '2rem' }}
                    className='useButton'>
                    <FormattedMessage id='search-page.use' />
                </Button>
            </Container>
        </>
    )
}

export default SelectCutCombination
